module.exports = __webpack_public_path__ + "assets/salesforce.353d4a1b.svg";